export const notifications = {
  loginSuccess: 'Login has been successfully',
  logoutSuccess: 'Logout has been successfully',
  resetPasswordSuccess: 'Password has been successfully changed',
  somethingWentWrong: 'Something went wrong',
};
